import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

import '@fontsource/raleway/400.css'; // Weight 400.
import '@fontsource/raleway/700.css'; // Weight 400.
import '@fontsource/raleway/900.css'; // Weight 400.

import '@fontsource/lato/400.css'; // Weight 400.
import '@fontsource/lato/100.css'; // Weight 400.
import '@fontsource/lato/300.css'; // Weight 400.

// Global Style
export const GlobalStyle = createGlobalStyle`
  html {
    background: ${theme.bgWhite};
    transition: all 150ms linear;

    @media (min-width: 320px) {
    font-size: 12px;
    }
    @media (min-width: 600px) {
      font-size: 14px;
    }
    @media (min-width: 768px) {
      font-size: 16px;
    }
  }

  html,
body,
#root {
  margin: 0;
  padding: 0;
}


#root {
  font-family: 'Lato';
  min-height: 100vh;
  height: 100vh;
}

.dmamc-animated-container {
  position: relative;
  height: 100%;
  width: 100%;
}
.dmamc-animated-logo {
  @media (min-width: 320px) {
    height: 80px;
    width: 80px;
  }

  @media (min-width: 1200px) {
    height: 645px;
    width: 645px;
  }
}

.dmamc-animated-logo-home {
  height: 250px;
  width: 250px;
  justify-content: center;
  @media (min-width: 1200px) {
    width: 392px;
    height: 543px;
  }
}

.ant-tree li ul li .ant-tree-node-content-wrapper {
  height: auto;
}

.ant-tree-treenode-switcher-open > ul > .ant-tree-treenode-checkbox-checked {
  display: flex;
  align-items: center;
}

.ant-tree-treenode-switcher-close > ul > .ant-tree-treenode-checkbox-checked {
  display: flex;
  align-items: center;
}

.editFavoriteCollection {
  z-index: 1500;
}

.ant-modal-wrap {
  z-index: 1500 !important;
}

.ant-select-dropdown {
  z-index: 10000 !important;
}


`;

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`,
};
